import mobileCarousel from "../modules/utils/mobileCarousel";

mobileCarousel('section-advantage__advantages-wrapper', 'section-advantage__arrow', 1.2);

mobileCarousel('section-advantage__slider', 'section-advantage__movies__arrow', 1.1, 16, false, 991.98, false);

const sections = document.querySelectorAll('.section-advantage');
let popup = null;
let popupOverlay = null;
let closePopUpButton = null;


const closePopUp = () => {
    popup.classList.add('fade-out');
    setTimeout(() => {
        document.querySelector('body').removeChild(popup);
    }, 500);
}

const closePopUpHandler = () => {
    closePopUpButton.addEventListener("click", closePopUp);
    popupOverlay.addEventListener("click", closePopUp);
} 

const createPopUp = async (card) => {
    const type = card.dataset.type;
    const content = card.dataset.content;
    const footer = document.querySelector('footer');
    card.classList.add("-block");
    
    if(content) {
        const {url} = ajax;
        try {
            const data = new FormData();
            data.append('action', 'show_popup');
            data.append('content', content);
            data.append('type', type);
            const response = await fetch(url, {
                body: data,
                method: 'POST',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();
            const {html} = responseData;
            const jsElement = document.createElement('div');
            jsElement.classList.add('popup');
            jsElement.innerHTML = html;
            footer.before(jsElement);

            popup = document.querySelector('.popup');
            popupOverlay = popup.querySelector('.popup__overlay');
            closePopUpButton = popup.querySelector('.popup__close-popup');

            if (type === 'own') {
                const video = popup.querySelector('video');
                video.controls = true;
                video.play();
            }

            closePopUpHandler();
        } catch (error) {
            console.log(error);
        } finally {
            card.classList.remove("-block");
        }

    }
}


sections.forEach(section => {

    const movieCardsWrappers = section.querySelectorAll('.section-advantage__single-movie');

    movieCardsWrappers.forEach(card => {

        card.addEventListener("click", () => createPopUp(card));
        
    });
    
});